/**
 * Cookie Control Component
 * 
 * Controls display based on cookie existence and value
 * 
 * @package TopBuddy
 */

import { ToggleControl, TextControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import ProBadge from '../ProBadge';

const CookieControl = ({ enabled, name, value, onEnabledChange, onNameChange, onValueChange }) => {
	const postSettingsData = window.topbuddyPostSettings || {};
	const isProActive = postSettingsData.isProActive || false;
	const upgradeUrl = postSettingsData.upgradeUrl || 'https://wptopbuddy.com/?utm_source=plugin&utm_medium=topbuddy-free-plugin&utm_campaign=topbuddy-free-plugin-admin';

	return (
		<div className="topbuddy-display-rules__field">
			<ToggleControl
				label={
					<>
						{__('Cookie', 'topbuddy')}
						{!isProActive && <ProBadge upgradeUrl={upgradeUrl} />}
					</>
				}
				help={__('Show notification only if specific cookie exists (and optionally matches value)', 'topbuddy')}
				checked={enabled}
				onChange={onEnabledChange}
				disabled={!isProActive}
				__nextHasNoMarginBottom
			/>
			
			{enabled && isProActive && (
				<>
					<TextControl
						label={__('Cookie name', 'topbuddy')}
						placeholder={__('e.g., user_preference, promo_code', 'topbuddy')}
						value={name}
						onChange={onNameChange}
						style={{ marginTop: '8px' }}
						__next40pxDefaultSize
						__nextHasNoMarginBottom
					/>
					<TextControl
						label={__('Cookie value (optional)', 'topbuddy')}
						placeholder={__('Leave empty to only check if cookie exists', 'topbuddy')}
						value={value}
						onChange={onValueChange}
						help={__('If provided, the cookie value must match exactly. Leave empty to check only for cookie existence.', 'topbuddy')}
						style={{ marginTop: '8px' }}
						__next40pxDefaultSize
					/>
				</>
			)}
		</div>
	);
};

export default CookieControl;
